import { platform } from "@/utils/platform";
import React from "react";
import FloatingTopBar from "../FloatingTopBar";
import NavHeader4App from "../NavHeader4App";


interface LeftTopBtnBoxProps {
  isSticky?: boolean; // H5专用，是否吸顶
  statusBarHeight?: number; // app专用，状态栏高度
}

/**
 * 左上角悬浮的按钮盒子组件
 * H5显示返回+home按钮，App只显示返回按钮，小程序什么都不显示
 */
const LeftTopBtnBox: React.FC<LeftTopBtnBoxProps> = ({ 
  isSticky = false, 
  statusBarHeight = 50 
}) => {
    const {isApp, isH5} = platform || {};
    // H5导航栏，(左侧返回按钮+home胶囊，吸顶时，中间多一个"全场100%正品")
    if(isH5){
      return <FloatingTopBar isSticky={isSticky} />;
    }
    // App显示返回按钮，App是通顶的，没有自带返回按钮，所以需要展示
    if(isApp){
      return (
        <NavHeader4App
          rankName={"热卖榜单"}
          statusBarHeight={statusBarHeight}
          isTabSticky={isSticky} 
        />
      );
    }
    // 小程序自带导航栏，导航栏有返回按钮，所以什么都需要不额外显示
    return null;
};

export default LeftTopBtnBox;